import {
  PURCHASE_ORDER_ALL,
  PURCHASE_ORDER_CREATE,
  PURCHASE_ORDER_DELETE,
  PURCHASE_ORDER_GET,
  PURCHASE_ORDER_UPDATE,
  PURCHASE_ORDER_ERROR,
} from "../../actions/types"

const initialState = {
  isLoading: false,
}
export default function PurchaseOrderReducer(state = initialState, action) {
  switch (action.type) {
    case PURCHASE_ORDER_ALL:
      return {
        arr: action.payload?.rows,
        currPage: action.payload?.currPage,
        lastPage: action.payload?.lastPage,
        isLoading: true,
        total: action.payload?.total,
      }
    case PURCHASE_ORDER_GET:
      return {
        ...action.payload,
        isLoading: true,
      }
    case PURCHASE_ORDER_CREATE:
      return { isLoading: false }
    case PURCHASE_ORDER_UPDATE:
      return { isLoading: false }
    case PURCHASE_ORDER_DELETE:
      return { isLoading: false }
    case PURCHASE_ORDER_ERROR:
      return { isLoading: false }
    default:
      return state
  }
}
